module.exports = __webpack_public_path__ + "static/media/editicon.643db6b2.svg";